var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo",class:{'custom-logo': !_vm.default_logo}},[(_vm.default_logo)?_c('span',{staticClass:"pp-icon pp-icon-logo"}):_vm._e(),(_vm.default_logo)?_c('span',{staticClass:"pp-icon-chief"}):_vm._e(),(!_vm.default_logo)?_c('img',{attrs:{"src":_vm.custom_logo}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }